import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "external-invoices" }
const _hoisted_2 = { class: "invoices-body" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "invoices-header company" }
const _hoisted_5 = { class: "invoices-header date" }
const _hoisted_6 = { class: "invoices-header invoiceNumber" }
const _hoisted_7 = { class: "invoices-header total" }
const _hoisted_8 = { class: "invoices-header invoiceStatus" }
const _hoisted_9 = {
  key: 0,
  class: "loading apollo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginatedEntitiesList = _resolveComponent("PaginatedEntitiesList")!
  const _component_EditInvoiceProject = _resolveComponent("EditInvoiceProject")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t("labels.company")), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t("labels.date")), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t("labels.invoiceNumber")), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t("labels.total")), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t("labels.invoiceStatus")), 1),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "option-icon" }, null, -1))
        ]),
        _createVNode(_component_PaginatedEntitiesList, {
          query: _ctx.GET_INDEPENDENT_INVOICES,
          items: _ctx.invoices,
          "onUpdate:items": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.invoices) = $event)),
          hasCheckBox: false,
          onActionOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal($event)))
        }, null, 8, ["query", "items"])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.t("loading")), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isModalVisible)
      ? (_openBlock(), _createBlock(_component_EditInvoiceProject, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal())),
          invoice: _ctx.clickedInvoice
        }, null, 8, ["invoice"]))
      : _createCommentVNode("", true)
  ], 64))
}